export default "__VITE_ASSET__FFhZ9m0J__"